/**
* コレクションページ ランキング表示用
*
*/

// globofilter, GloboEmbedFilterConfig
const getRanking = async () => {
    /**
    * パラメータの準備
    */
    let params = JSON.parse(JSON.stringify(globofilter.state.queryParams))
    params.page_type = globofilter.shop.page
    params.sort_by = 'mf-custom-order-descending' // 商品並び順：本番環境では名称が変わる可能性がある
    params.event = 'init' // イベント
    params.limit = 5 // 表示対象件数（最大○○件）
    params.page = 1 // ページネーションのページ番号
    const paramOfexcludeTags = params?.excludeTags?.map(x => `excludeTags[]=${encodeURI(x)}`).join('&') // 対象外のタグ一覧の取得＆設定
    /**
    * 在庫ありの商品のみを取得するためのパラメーター設定
    */
    const inventryStatusFilter = globofilter.state.filters.find(filter => filter.attribute?.toLowerCase() == 'availability')
    const inStock = inventryStatusFilter.values.find(x => x.label == '在庫あり' || x.label?.toLowerCase() == 'in stock')
    const paramOfInStock = "filter[" + inventryStatusFilter.handle + "][]" + "=" + (inStock?.value ?? 1)

    /**
    * 不要なパラメーターの削除（不正な形式のパラメーターのため削除）
    */
    delete params.filter
    delete params.excludeTags
    const queryParams = new URLSearchParams(params)
    queryParams.delete('filter')

    /**
    * 送信処理（アプリのJSを基にコード化）
    */
    const url = GloboEmbedFilterConfig.api.url + "/api/apiFilter"
    const e = new AbortController
        , t = setTimeout(() => {
            e.signal.aborted || e.abort("timeout")
        }
            , window.filterAjaxTimeOut || 15e3)
        , s = await fetch(`${url}?${queryParams}&${paramOfInStock}&${paramOfexcludeTags}`, {
            method: "GET",
            cache: "default",
            signal: e.signal,
            priority: "high"
        })
    if (clearTimeout(t), !s.ok)
        throw new Error(`HTTP error! status: ${s.status}`)

    /**
    * データの取得
    */
    const rs = await s.json()
    
    /**
    * データのパース
    */
    let items = []
    for (let product of rs.products) {
        let item = {
            handle: product.handle,
            title: product.title,
            tags: product.tags,
            available: product.available,
            image: product.image?.src ?? '',
            alt: product.image?.alt ?? product.title,
            order: 0
        }
        try {
            const res = await fetch(`/products/${product.handle}?view=ranking-api`)
            const data = await res.json()
            item.price = data.price
            item.priceVaries = data.priceVaries
            item.comparedAtPrice = data.comparedAtPrice
            item.discountedRatio = data.discountedRatio
            item.is_sale = data.is_sale
            item.is_show = data.is_show
            item.order = data.amount == null ? 0 : data.amount
        } catch (err) {
            console.error(err)
        }
        items.push(item)
    }
    return items
}

// スライダー表示判定・切替用（SPのみ swiper）
let swiper = null;
function checkSwiper() {
    const w = document.documentElement.clientWidth; 

    if (w <= 768) {

        if (swiper) return;

        swiper = new Swiper('.ranking_container', {
            on: {
                _beforeBreakpoint:function(){
                    // 2個以下でナビゲーションを非表示、loopをキャンセルにする
                    let elmCollectionRankingItem = this.wrapperEl.getElementsByClassName("swiper-slide");
                    let elmNaviBtnNext = this.el.getElementsByClassName("swiper-button-next");
                    let elmNaviBtnPrev = this.el.getElementsByClassName("swiper-button-prev");
                    if( elmCollectionRankingItem.length <= 2){
                        elmNaviBtnNext[0].style.display = "none";
                        elmNaviBtnPrev[0].style.display = "none";
                        this.params.loop = false;
                    }
                }
            },
            slidesPerView: 2.3,
            spaceBetween: 15,
            updateOnWindowResize: true,
            centeredSlides: false,
            watchOverflow: true,
            roundLengths: true,
            speed: 1000,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

    } else {
            if (swiper) {
            swiper.destroy(true, true);
            swiper = null;
        }

    }
}

// ラベルタグ生成
function label_tag_create(tags,available,is_sale){
    if (available === false){
        return `<div class="grid-product__tag grid-product__tag--sold-out">sold out</div>`
    }else{
        let return_html = ''
        if(is_sale === true){
            return_html += `<div class="grid-product__tag grid-product__tag--sale">SALE</div>`
        }
        return_html += (tags ?? []).map(tag => {

            if( tag == "NEW"){
                return `<div class="grid-product__tag grid-product__tag--new">NEW</div>`;
            }else if(tag == "送料無料"){
                return `<div class="grid-product__tag grid-product__tag--shipping">送料無料</div>`;
            }else if(tag == "予約商品"){
                return `<div class="grid-product__tag grid-product__tag--reservation">予約商品</div>`;
            }else if(tag == "特典付き"){
                return `<div class="grid-product__tag grid-product__tag--benefits">特典付き</div>`;
            }else if(tag == "限定品"){
                return `<div class="grid-product__tag grid-product__tag--limited">限定品</div>`;
            }else if(tag == "数量限定"){
                return `<div class="grid-product__tag grid-product__tag--quantity">数量限定</div>`;
            }else if(tag == "アウトレット"){
                return `<div class="grid-product__tag grid-product__tag--outlet">アウトレット</div>`;
            }else if(tag == "ポイントアップ"){
                return `<div class="grid-product__tag grid-product__tag--pointup">ポイントアップ</div>`;
            }else if(tag == "定期便"){
                return `<div class="grid-product__tag grid-product__tag--teiki">定期便</div>`;
            }
        }).join('');

        return return_html;
    }

}

window.addEventListener('load', async () => {
    let id = null
    const prepareTask = ()=>{
      return new Promise((resolve)=>{
        id = setInterval(()=>{
            if(globofilter?.state?.filters != null && globofilter.state?.filters.find(filter => filter?.attribute?.toLowerCase() == 'availability') != null){
              clearInterval(id)
              resolve()
            }
        }, 100)
      })
    }
    await prepareTask()

    const rankingElm = document.querySelector('#ranking')
    const items = await getRanking()
    let html = ''
    const hasShowItem = items.some(
        item => item.is_show !== false && item.order >= 1
    );
    if(hasShowItem){
        html += /*html*/`
            <h3>カテゴリ内売れ筋ランキング</h3>
            <div class="ranking_container">
                <ul class="swiper-wrapper">
                    ${items.map((x, index) => {

                        if (x.order < 1 || x.is_show === false) return ''

                        const tagHtml = label_tag_create(x.tags, x.available, x.is_sale);

                        return /*html*/`
                        <li class="swiper-slide">
                            <a href="/products/${x.handle}">
                                <figure><img src="${x.image}" alt="${x.alt}"></figure>
                                <div class="grid-product__tags">
                                    ${tagHtml}
                                </div>
                                <p class="grid-product__title">${x.title}</p>
                                <p class="grid-product__price">
                                    <span class="grid-product__price--current">${x.priceVaries === true? `from ${x.price}`: x.price}</span>
                                    ${x.is_sale === true ? `<span class="grid-product__price--original">${x.comparedAtPrice}</span>
                                    <span class="grid-product__price--savings">${x.discountedRatio}%OFF</span>`: ``}
                                </p>
                                <!--<p>購入数:${x.order}</p>-->
                                <div class="ranking_num ranking_num${index+1}">${index+1}</div>
                            </a>
                        </li>
                        `
                        }).join('')
                    }
                </ul>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
        `
    }

    
    // 実レンダリング処理
    rankingElm.innerHTML = html

    // 端末ごとにUI出しわけ
    checkSwiper();

    // リサイズ時もUI出しわけ
    window.addEventListener('resize', checkSwiper);

})

